// extracted by mini-css-extract-plugin
export var autoExpand = "_1f-8";
export var container = "_1f-7";
export var containerWidth = "_1f-5";
export var disabled = "_1f-2";
export var error = "_1f-3";
export var fullWidth = "_1f-6";
export var inputWrapper = "_1f-0";
export var small = "_1f-1";
export var textarea = "_1f-4";